exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/components/page-not-found/page-not-found.component.css
// module id = ../../../../../src/app/components/page-not-found/page-not-found.component.css
// module chunks = main